import queryString from 'query-string';
import { createAxiosInstance } from '@/plugins/axios.plugin';

export class EnrollmentUser {
  static SERVICE_NAME = 'enrollmentUser';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  createEnrollments({ academicMainId, users, roleCourseId, enrollmentStatusId, startDate, endDate }) {
    return this.client.post('academic/courses/enrollment', { academicMainId, users, roleCourseId, enrollmentStatusId, startDate, endDate });
  }

  getNotEnrolled({ academicMainId, type, filter, page }) {
    const stringified = queryString.stringify({ type, filter, page }, { skipNull: true, skipEmptyString: true });
    return this.client.get(`/academic/courses/${academicMainId}/enrollment/user/not_enrolled${stringified && `?${stringified}`}`);
  }

  getParticipants(params) {
    const stringified = queryString.stringify(params, { skipNull: true, skipEmptyString: true });
    return this.client.get(`/academic/courses/enrollment${stringified && `?${stringified}`}`);
  }

  update({ userId, roleCourseId, enrollmentStatusId, startDate, endDate }) {
    return this.client.put(`/academic/courses/enrollment/${userId}`, {
      roleCourseId,
      enrollmentStatusId,
      startDate,
      endDate
    });
  }

  delete(id) {
    return this.client.delete(`academic/courses/enrollment/${id}`);
  }

  deleteDelivery({ enrollmentId, topicId, attemptNumber, topicType }) {
    return this.client.delete(`/content/enrollment/${enrollmentId}/topic/${topicId}/attempt/${attemptNumber}?type=${topicType}`);
  }

  deletePost({ enrollmentId, topicId, postId }) {
    return this.client.delete(`/content/enrollment/${enrollmentId}/topic/${topicId}/post/${postId}`);
  }

  getStudents(params) {
    const stringified = queryString.stringify({
      page         : params.data.page,
      perPage      : params.data.perPage,
      filter       : params.data.search,
      order        : params.data.order,
      sortBy       : params.data.sortBy,
      roleCourseId : params.data.roleCourseId,
      fullListing  : params.data.fullListing
    }, { skipNull: true, skipEmptyString: true });

    return this.client.get(`/academic/academics-main/${params.academicMain}/enrollments${stringified && `?${stringified}`}`);
  }
}

export default new EnrollmentUser();